

























































































import { Component, Vue } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { Provider } from '@/models'
import { Utils } from '@/utils'
import UpsertProviderModal from '@/components/modals/UpsertProviderModal.vue'

@Component({
  components: { UpsertProviderModal }
})
export default class Providers extends Vue {
  private providers: Provider[] = []
  private loading = false
  private searchFilter = ''
  private selectedProvider: Provider = { id: 0, name: '', responsibleId: '' }

  private fields = [
    { key: 'id', label: 'ID', sortable: true },
    { key: 'name', label: this.$t('providers_view.columns.name'), sortable: true },
    { key: 'responsibleId', label: this.$t('providers_view.columns.responsible'), sortable: true },
    { key: 'createdOn', label: this.$t('providers_view.columns.created_on'), sortable: true },
    { key: 'actions', label: this.$t('table.actions'), sortable: false, class: 'text-center' }
  ]

  get filteredProviders(): Provider[] {
    if (!this.searchFilter.trim()) return this.providers
    const filterNormalized = Utils.normalizeText(this.searchFilter)
    return this.providers.filter(provider => {
      const name = Utils.normalizeText(provider.name)
      const responsible = Utils.normalizeText(provider.responsibleId)
      return name.includes(filterNormalized) || responsible.includes(filterNormalized)
    })
  }

  async created() {
    await this.loadProviders()
  }

  async loadProviders() {
    try {
      this.loading = true
      this.providers = await ApiClient.getProviders()
    } catch (error) {
      console.error('Error loading providers:', error)
      this.$bvToast.toast(this.$t('providers_view.error_loading').toString(), {
        title: this.$t('providers_view.error_title').toString(),
        variant: 'danger',
        solid: true
      })
    } finally {
      this.loading = false
    }
  }

  openCreateModal() {
    this.selectedProvider = { id: 0, name: '', responsibleId: '' }
    this.$nextTick(() => this.$bvModal.show('UpsertProviderModal'))
  }

  openEditModal(provider: Provider) {
    this.selectedProvider = { ...provider }
    this.$nextTick(() => this.$bvModal.show('UpsertProviderModal'))
  }

  async onProviderSaved() {
    await this.loadProviders()
    this.$bvToast.toast(this.$t('providers_view.saved_success').toString(), {
      title: this.$t('feedback.feedback_message_success_title').toString(),
      variant: 'success',
      solid: true,
      autoHideDelay: 2000
    })
  }

  async confirmDelete(provider: Provider) {
    const confirmed = await this.$bvModal.msgBoxConfirm(
      this.$t('providers_view.confirm_delete', { name: provider.name }).toString(),
      {
        title: this.$t('providers_view.confirm_delete_title').toString(),
        okVariant: 'danger',
        okTitle: this.$t('button_actions.remove').toString(),
        cancelTitle: this.$t('button_actions.cancel').toString(),
        centered: true
      }
    )

    if (!confirmed) return

    try {
      await ApiClient.deleteProvider(provider.id)
      this.$bvToast.toast(this.$t('providers_view.deleted_success').toString(), {
        title: this.$t('feedback.feedback_message_success_title').toString(),
        variant: 'success',
        solid: true
      })
      await this.loadProviders()
    } catch (error: any) {
      console.error('Error deleting provider:', error)
      this.$bvToast.toast(error.message || this.$t('providers_view.error_deleting').toString(), {
        title: this.$t('providers_view.error_title').toString(),
        variant: 'danger',
        solid: true
      })
    }
  }
}
